import api from '../utils/api';
import { RoleTemplate, UserPermissionOverride } from '../types';

export const permissionService = {
  async getMyPermissions(organizationId: string): Promise<Record<string, boolean>> {
    const response = await api.get(`/organizations/${organizationId}/permissions/me`);
    return response.data;
  },

  async getRoleTemplates(organizationId: string): Promise<RoleTemplate[]> {
    const response = await api.get(`/organizations/${organizationId}/permissions/role-templates`);
    return response.data;
  },

  async getRoleTemplate(organizationId: string, roleName: string): Promise<RoleTemplate | null> {
    try {
      const response = await api.get(`/organizations/${organizationId}/permissions/role-templates/${roleName}`);
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  async updateRoleTemplate(
    organizationId: string,
    roleName: string,
    template: Partial<RoleTemplate>
  ): Promise<RoleTemplate> {
    const response = await api.put(`/organizations/${organizationId}/permissions/role-templates/${roleName}`, template);
    return response.data;
  },

  async getUserOverrides(organizationId: string, userId: string): Promise<UserPermissionOverride | null> {
    try {
      const response = await api.get(`/organizations/${organizationId}/permissions/users/${userId}/overrides`);
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  async updateUserOverrides(
    organizationId: string,
    userId: string,
    overrides: Partial<UserPermissionOverride>
  ): Promise<UserPermissionOverride> {
    const response = await api.put(`/organizations/${organizationId}/permissions/users/${userId}/overrides`, overrides);
    return response.data;
  },

  async deleteUserOverrides(organizationId: string, userId: string): Promise<void> {
    await api.delete(`/organizations/${organizationId}/permissions/users/${userId}/overrides`);
  },
};
